import { render } from "./CCIndex.vue?vue&type=template&id=2b3afd06&scoped=true&ts=true"
import script from "./CCIndex.vue?vue&type=script&lang=ts"
export * from "./CCIndex.vue?vue&type=script&lang=ts"

import "./CCIndex.vue?vue&type=style&index=0&id=2b3afd06&scoped=true&lang=less"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3afd06"]])

export default __exports__